import * as _ from "underscore";

import * as mustcache from "mustcache";

const GenericPage = function (
  pageName: string,
  template: string,
  options?: { templateData?: { [key: string]: any }; showHeader?: boolean }
) {
  this.options = options || {};
  _.defaults(this.options, {
    templateData: {},
    showHeader: true,
  });

  this.name = pageName;
  this.template = template;
  this.showHeader = this.options.showHeader;
};

GenericPage.prototype.render = function (element, renderedCallback) {
  element.html(mustcache.render(this.template, this.options.templateData));
  renderedCallback();
};

export default GenericPage;
